// Author YuJiaBei
// Date 2021-08-03 17:24:02

import * as model from "@/model/sithMes/prd/SithMesPrdPdsrRPrpPdrpModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPdsrRPrpPdrp(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
    })
    .buildStore()
